import React, {useState} from "react";
import {resetMenu} from "../redux/slices/menuSlice";
import {useDispatch} from "react-redux";
import { Table, Space, Pagination } from 'antd';
import EntityApi from "../api/EntityApi";
import { SearchOutlined } from '@ant-design/icons';
import Input from "../components/element/Input";
import Button from "../components/element/Button";
import {Link} from "react-router-dom";

const AccessesPage = () => {

    const dispatch = useDispatch();
    const [dataSource, setDataSource] = useState([]);
    const [inputSearchClient, setInputSearchClient] = useState('');
    const [inputSearchProduct, setInputSearchProduct] = useState('');
    const [sortField, setSortField] = useState('dt');
    const [sortOrder, setSortOrder] = useState('desc');
    const [isLoading, setIsLoading] = useState(false);
    const [isFilter, setIsFilter] = useState(false);
    const [isReload, setIsReload] = useState(false);
    const [total, setTotal] = React.useState(0);
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);


    const handleIsFilter = () => {
        setIsFilter(false);
        if (inputSearchClient.length > 0 || inputSearchProduct.length > 0) {
            setIsFilter(true);
        }
    }

    const handleResetFilter = () => {
        setInputSearchClient('');
        setInputSearchProduct('');
        setIsReload(!isReload);
    }

    const handleSearchClient = (selectedKeys, confirm) => {
        confirm();
        setIsReload(!isReload);
    };
    const handleResetClient = (confirm) => {
        setInputSearchClient('');
        confirm();
        setIsReload(!isReload);
    };

    const handleSearchProduct = (selectedKeys, confirm) => {
        confirm();
        setIsReload(!isReload);
    };
    const handleResetProduct = (confirm) => {
        setInputSearchProduct('');
        confirm();
        setIsReload(!isReload);
    };

    const getColumnSearchClient = () => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div className={'p-2'}>
                <Input type='text' onChange={(value) => setInputSearchClient(value)} value={inputSearchClient} placeholder={'Номер телефона или имя'} />
                <Space className={'pt-2'}>
                    <Button text={'Найти'} type={'primary'} onClick={() => handleSearchClient(selectedKeys, confirm)}/>
                    <Button text={'Сбросить'} type={'default'} onClick={() => confirm && handleResetClient(confirm)}/>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        )
    })

    const getColumnSearchProduct = () => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div className={'p-2'}>
                <Input type='text' onChange={(value) => setInputSearchProduct(value)} value={inputSearchProduct} placeholder={'Код или название'} />
                <Space className={'pt-2'}>
                    <Button text={'Найти'} type={'primary'} onClick={() => handleSearchProduct(selectedKeys, confirm)}/>
                    <Button text={'Сбросить'} type={'default'} onClick={() => confirm && handleResetProduct(confirm)}/>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        )
    })

    const columns = [
        {
            title: 'Информация о доступе',
            responsive: ['xs'],
            ...getColumnSearchClient(),
            render: (item) => {
                return <>
                    <div><span className={'font-bold'}>Дата: </span>{item.dt}</div>
                    <div><span className={'font-bold'}>ФИО: </span>{item.client}</div>
                    <div><span className={'font-bold'}>Телефон: </span>{item.login}</div>
                    <div><span className={'font-bold'}>Курс: </span>{item.title}</div>
                    <div><span className={'font-bold'}>Сроки: </span>{item.access}</div>
                    <div><span className={'font-bold'}>Заказ: </span>{item.order}</div>
                </>
            }
        },
        {
            title: 'Дата',
            width: 150,
            dataIndex: 'dt',
            responsive: ['md'],
            sorter: true
        },
        {
            title: 'ФИО',
            width: 300,
            dataIndex: 'client',
            responsive: ['md'],
            ...getColumnSearchClient(),
            render: (client, data) => <Link to={'/cabinet/users/' + data.clientId}>{data.client}</Link>
        },
        {
            title: 'Телефон',
            //width: 300,
            dataIndex: 'login',
            responsive: ['md'],
            ...getColumnSearchClient(),
            render: (login, data) => <Link to={'/cabinet/users/' + data.clientId}>{data.login}</Link>
        },
        {
            title: 'Курс',
            dataIndex: 'title',
            responsive: ['md'],
            ...getColumnSearchProduct()
        },
        {
            title: 'Сроки',
            width: 200,
            responsive: ['md'],
            dataIndex: 'access',
        },
        {
            title: 'Заказ',
            width: 150,
            responsive: ['md'],
            dataIndex: 'order',
        }
    ];

    const getList = () => {
        setIsLoading(true);
        handleIsFilter();
        EntityApi.getBy('private/access', {
            filter: {
                client: inputSearchClient,
                product: inputSearchProduct
            },
            sort: {
                [sortField]: sortOrder
            },
            size: pageSize,
            page: page
        }).then((data) => {
            setIsLoading(false);
            if (data.status === EntityApi.STATUS_SUCCESS) {
                let items = [];
                if (data.content.items) {
                    data.content.items.forEach((content) => {

                        let access = '';
                        if (content.date_from) {
                            access += 'от ' + content.date_from;
                        }
                        if (content.date_to) {
                            access += ' до ' + content.date_to;
                        }
                        if (!access) {
                            access = 'Бессрочно';
                        }

                        let item = {
                            key: content.id,
                            dt: content.dt,
                            clientId:  content.client.id,
                            login:  content.client.login,
                            company:  content.client.company,
                            client: content.client.surname + ' ' +  content.client.name + ' ' + content.client.fathername,
                            title: content.title,
                            access: access,
                            order: content.order_id ? 'Заказ №' + content.order_id : 'Без заказа',
                        }
                        items.push(item);
                    });
                }
                setDataSource(items);
                setTotal(data.payload.total);
                setPage(data.payload.currentPage);
            }
        });
    }

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter.hasOwnProperty("column")) {
            if (sorter.field !== undefined) {
                setSortField(sorter.field);
            } else {
                setSortField('id');
            }
            if (sorter.order === 'ascend') {
                setSortOrder('asc');
            }
            if (sorter.order === 'descend') {
                setSortOrder('desc');
            }
        } else {
            setSortField('id');
            setSortOrder('desc');
        }
        setIsReload(!isReload);
    }

    const onPaginate = (p) => {
        setPage(p);
        setIsReload(!isReload);
    }

    React.useEffect(() => {
        dispatch(resetMenu());
        getList();
    }, [isReload])

    return <>
        <div className="flex items-center justify-between py-5 lg:py-6">
            <div className="flex items-center space-x-1">
                <h2 className="line-clamp-1 text-xl font-medium text-slate-700 dark:text-navy-50 lg:text-2xl">
                    Доступы пользователей
                </h2>
            </div>
        </div>
        <div className="card px-4 pb-4">
            <div className="my-3 flex h-8 items-center justify-between">
                <h2 className="line-clamp-1 font-medium tracking-wide text-slate-700 dark:text-navy-100 lg:text-base">
                    Список доступов
                </h2>
            </div>
            { isFilter &&
                <div style={{marginBottom: '0.5rem'}} className="alert flex items-center rounded-lg border border-info/30 bg-info/10 py-4 px-4 text-info sm:px-5">
                    <div>Применен фильтр:</div>
                    {
                        inputSearchClient && <div className={'pl-4'}>Клиент - <b>{inputSearchClient}</b></div>
                    }
                    {
                        inputSearchProduct && <div className={'pl-4'}>Название - <b>{inputSearchProduct}</b></div>
                    }
                    <div className={'pl-4'} style={{width: '100px'}}>
                        <Button text={'Сбросить'} type={'infoSmall'} onClick={handleResetFilter} />
                    </div>
                </div>
            }
            <Table loading={isLoading} onChange={handleTableChange} columns={columns} dataSource={dataSource} pagination={false}></Table>
            <div className={'pt-3'}>
                <Pagination defaultCurrent={page} pageSize={pageSize} showSizeChanger={true} onShowSizeChange={(current, size) => setPageSize(size)} onChange={onPaginate} total={total}/>
            </div>
        </div>
    </>

}

export default AccessesPage;
